import type { IconData } from '@stacksjs/iconify-core'

export const smileysHappy: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M5 6a1 1 0 1 0 0-2a1 1 0 0 0 0 2m7 2a4 4 0 0 1-8 0zm0-3a1 1 0 1 1-2 0a1 1 0 0 1 2 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default smileysHappy
